
import "@fontsource/manrope/400.css"
import "@fontsource/manrope/600.css"
import "@fontsource/manrope/700.css"
import "@fontsource/noto-serif/400.css"
import "@fontsource/noto-serif/700.css"

import { ChakraProvider } from "@chakra-ui/react"
import { celestialSystem } from "@/theme"
import { Toaster } from "./toaster"
import {
  ColorModeProvider,
  type ColorModeProviderProps,
} from "./color-mode"

export function Provider(props: ColorModeProviderProps) {
  return (
    <ChakraProvider value={celestialSystem}>
      <ColorModeProvider {...props} />
      <Toaster />
    </ChakraProvider>
  )
}
